// as per LR.Hb.Api.Models.ModelStatus
export enum ModelStatus {
  Draft = 0,
  Validated = 1,
  Published = 2,
  Certified = 3,
}
